import { ReactNode } from 'react';

import { PermissionProvider as Provider } from '@apigrowfinance/pbolt-permission-provider';
// eslint-disable-next-line import/no-unresolved
import { Auth } from 'auth/services/Auth';

import { PERMISSIONS_MAP } from '@utils/permissionsMap';

const auth = Auth.getInstance();

const PermissionProvider = ({ children }: { children: ReactNode }) => {
    const rolesThatHavePermissions = auth
        .getUser()
        ?.roles.filter((role: string) =>
            Object.keys(PERMISSIONS_MAP).includes(role),
        );

    // Currently, the only role that will match will be owner. Will need to change this in the future
    const permissions = rolesThatHavePermissions?.length
        ? PERMISSIONS_MAP[
              rolesThatHavePermissions[0] as keyof typeof PERMISSIONS_MAP
          ]
        : [];

    return <Provider permissions={permissions}>{children}</Provider>;
};

export default PermissionProvider;
